import { useMemo } from 'react';
import { Select } from 'components/partials/Fields/FormikSelect';
import { useGlobalContext } from 'context/GlobalContext';
import { getIn, useFormikContext } from 'formik';


const TimeZones = ({
    ...props
}) => {

    const { values } = useFormikContext();
    const { countries } = useGlobalContext();
    const country_id = getIn(values, 'country_id');
    
    const timezones = useMemo(() => {
        if (!(country_id == '237' || country_id == '37') || !countries) {
            return false;
        }

        const country = countries.find(c => c.country_id == country_id);
        const { timezones: countriesTimezones = [] } = country ?? [];

        return countriesTimezones;
    }, [country_id, countries]);

    return (
        <Select
            formik
            name={props.name}
            label="Time Zone"
            attributes={props.attributes}
            updateMethod={props.updateMethod}
            disabled={props.disabled}
            addBlank={timezones}
            {...props}
        >
            {!timezones && (<option value="">Please Select a Country</option>)}
            {(timezones || []).map(({ timezone_id, timezone }) => {
                return <option key={timezone_id} value={timezone_id}>{timezone}</option>;
            })}
        </Select>
    );
};

export default TimeZones;